export default "__VITE_ASSET__BBXuwse6__"